import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Models
import { IBilling } from '../../interfaces/billing.interfaces';

export interface IBillingState {
  balance: IBilling;
  loading: boolean;
  error: string | null;
}

const initialState: IBillingState = {
  balance: {
    minutes: 0,
    correspondence: 0
  },
  loading: false,
  error: null,
};

export const billingSlice = createSlice({
  initialState,
  name: 'loader',
  reducers: {
    loadBillingBalanceRequest: (state): void => {
      state.loading = true;
      state.error = null;
    },
    loadBillingBalanceRequestError: (state, { payload: error }: PayloadAction<string>): void => {
      state.loading = false;
      state.error = error;
    },
    loadBillingBalanceRequestSuccess: (state, { payload: balance }: PayloadAction<IBilling>): void => {
      state.balance = balance;
      state.loading = false;
      state.error = null;
    }
  }
});

export const BillingSliceActions = billingSlice.actions;
